RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Downloads = Marionette.ItemView.extend({
        template: '#shellDownloadsTemplate',

        ui: {
            link: 'a',
            icon: '.fa'
        },

        events: {
            'click @ui.icon': 'onIconClick'
        },

        collectionEvents: {
            'add': 'showDownloadState',
            'remove': 'showDownloadState'
        },

        onAttach: function () {
            const me = this;

            me.showDownloadState();
        },

        onIconClick: function () {
            const me = this;
            me.ui.link.click();
        },

        showDownloadState: function () {
            const me = this;

            const pendingDownloads = (_.size(me.collection) > 0);

            me.ui.icon.toggleClass('loading-animate', pendingDownloads);

            if (pendingDownloads && RivalIQ.state.user.shouldShowTour('downloadLink')) {
                return me.showTour();
            }
        },

        showTour: function () {
            const tourOptions = {
                tourId: 'downloadLink',
                autoscroll: false,
                closeButtonText: 'Got it!',
                startDelay: 0,
                steps: [
                    {
                        element: '.section.panel.panel-default:last',
                        content: `<p>We're building your report and it will download when complete.</p> <p>You can view past reports in Downloads, under Reports.</p>`,
                        placement: 'top',
                        bodyClass: 'download-link-tour-1'
                    }
                ]
            };

            RivalIQ.execute('tour:start', tourOptions);
        }
    });

});
